/**
 * UNE AUTOFACTURE N'EST PAS UNE FACTURE DE MYFACTURE.
 *
 * Les Indés Radios et TF1 Publicité émettent ces factures AU NOM de la société
 * (autofacturation, art. 289-I-2 du CGI) : leur numéro, leur document. Ce que
 * MyFacture en garde est l'ENREGISTREMENT comptable, avec le PDF d'origine.
 *
 * La règle d'Amine (9 octobre 2026) : « on garde l'original, puisque même la
 * numérotation n'est pas celle de MyFacture ». Concrètement :
 *   — l'aperçu et le téléchargement servent le PDF d'ORIGINE, jamais la mise en
 *     page MyFacture : celle-ci, avec le logo de la société et le même numéro,
 *     ressemblerait à une seconde facture pour la même opération — et la TVA
 *     portée sur une facture est due par qui l'a émise (art. 283-3 du CGI) ;
 *   — ni envoi, ni duplication, ni modification. Le règlement, lui, se gère
 *     comme pour toute facture : c'est de la comptabilité, pas une émission.
 *
 * Ce module ne dépend de rien : il sert aux écrans comme aux actions serveur.
 */

/** Une facture portant une référence externe est une autofacture importée. */
export function estAutofacture(facture: { referenceExterne?: string | null } | null | undefined): boolean {
  return !!facture?.referenceExterne;
}

/** Qui l'a émise, en clair. */
export function emetteurAutofacture(referenceExterne: string | null | undefined): string {
  if (referenceExterne?.startsWith('TF1:')) return 'TF1 Publicité';
  if (referenceExterne?.startsWith('INDES:')) return 'Les Indés Radios';
  if (referenceExterne?.startsWith('META:')) return 'Meta Platforms Ireland';
  return 'un tiers';
}

/** Le PDF d'origine, servi tel qu'il a été déposé. */
export function urlDuPdfOriginal(factureId: string): string {
  return `/api/factures/${factureId}/original`;
}

export const REFUS_AUTOFACTURE =
  "Autofacture émise par un tiers au nom de la société : elle ne s'envoie, ne se duplique ni ne se modifie depuis MyFacture. Son original est le PDF de l'émetteur.";
